import { SnailyError } from './SnailyError'

export class BotStoppedError extends SnailyError {
	constructor(message: string, metadata?: unknown) {
		super(message, metadata)
		this.name = 'BotStoppedError'

		if (typeof Error.captureStackTrace === 'function') {
			Error.captureStackTrace(this, BotStoppedError)
		}
	}
}
